// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-gray: #d9d9d9;
  --white: #ffffff;
  --black: #000000;
  --transparent: rgba(255, 255, 255, 0.1);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.navbar {
  background: var(--transparent);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(217, 217, 217, 0.1);
  transition: all 0.3s ease;
  z-index: 1000;
}

/* Sticky only on desktop */
@media (min-width: 769px) {
  .navbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
  }
  
  /* Add padding to body to compensate for fixed navbar */
  body {
    padding-top: 80px;
  }
}

.navbar-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  background-color: #ffffff;
}

/* Logo Styles */
.navbar-logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: bold;
  color: var(--white);
}

.logo-f {
  background: var(--primary-gray);
  color: var(--black);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-size: 1.2rem;
  font-weight: bold;
}

.logo-text {
  color: #000000;
  font-size: 1.6rem;
  letter-spacing: 2px;
  font-weight: 400;
}

/* Desktop Menu */
.desktop-menu {
  display: flex;
  list-style: none;
  gap: 2rem;
}

.desktop-menu li a {
  color: var(--black);
  text-decoration: none;
  font-weight: 400;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  position: relative;
  padding: 0.5rem 0;
}

.desktop-menu li a:hover {
  color: var(--black);
}

.desktop-menu li a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 1px;
  background: var(--white);
  transition: width 0.3s ease;
}

.desktop-menu li a:hover::after {
  width: 100%;
}

/* Mobile Menu Button */
.mobile-menu-button {
  display: none;
  flex-direction: column;
  cursor: pointer;
  padding: 0.5rem;
  z-index: 1001;
}

.hamburger {
  width: 25px;
  height: 2px;
  background: var(--black);
  margin: 3px 0;
  transition: all 0.3s ease;
  transform-origin: center;
}

.mobile-menu-button.active .hamburger:nth-child(1) {
  transform: rotate(45deg) translate(6px, 6px);
}

.mobile-menu-button.active .hamburger:nth-child(2) {
  opacity: 0;
}

.mobile-menu-button.active .hamburger:nth-child(3) {
  transform: rotate(-45deg) translate(6px, -6px);
}

/* Mobile Menu */
.mobile-menu {
  position: fixed;
  top: 0;
  right: -100%;
  width: 280px;
  height: 100vh;
  -webkit-backdrop-filter: blur(20px);
  transition: right 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  z-index: 999;
}

.mobile-menu.active {
  right: 0;
}

.mobile-menu-items {
  z-index: 1001;
  list-style: none;
  padding: 100px 2rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.mobile-menu-items li {
  z-index: 1001;
  opacity: 0;
  transform: translateX(30px);
  transition: all 0.3s ease;
  transition-delay: 0.1s;
}

.mobile-menu.active .mobile-menu-items li {
  z-index: 1001;
  opacity: 1;
  transform: translateX(0);
}

.mobile-menu-items li:nth-child(1) { transition-delay: 0.1s; }
.mobile-menu-items li:nth-child(2) { transition-delay: 0.15s; }
.mobile-menu-items li:nth-child(3) { transition-delay: 0.2s; }
.mobile-menu-items li:nth-child(4) { transition-delay: 0.25s; }
.mobile-menu-items li:nth-child(5) { transition-delay: 0.3s; }
.mobile-menu-items li:nth-child(6) { transition-delay: 0.35s; }

.mobile-menu-items li a {
  color: var(--primary-gray);
  text-decoration: none;
  font-size: 1.1rem;
  font-weight: 300;
  padding: 1rem 0;
  display: block;
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(217, 217, 217, 0.1);
}

.mobile-menu-items li a:hover {
  color: var(--white);
  padding-left: 1rem;
}

/* Menu Overlay */
.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1001;
}

.menu-overlay.active {
  opacity: 1;
  visibility: visible;
}

/* Responsive Design */
@media (max-width: 768px) {
  .navbar-container {
    padding: 1rem 1.5rem;
  }
  
  .desktop-menu {
    display: none;
  }
  
  .mobile-menu-button {
    display: flex;
  }
  
  .logo-text {
    font-size: 1rem;
    letter-spacing: 1.5px;
  }
  
  .logo-f {
    width: 28px;
    height: 28px;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .navbar-container {
    padding: 1rem 1rem;
  }
  
  .mobile-menu {
    width: 100%;
  }
  
  .mobile-menu-items {
    z-index: 9999;
    padding: 80px 2rem 2rem;
  }
}

/* Smooth scrolling for anchor links */
html {
  scroll-behavior: smooth;
}

/* Hide scrollbar when menu is open */
body.menu-open {
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,mCAAmC;EACnC,iDAAiD;EACjD,yBAAyB;EACzB,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;EACV;;EAEA,uDAAuD;EACvD;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,aAAa;EACb,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,wBAAwB;AAC1B;;AAEA,qCAAqC,sBAAsB,EAAE;AAC7D,qCAAqC,uBAAuB,EAAE;AAC9D,qCAAqC,sBAAsB,EAAE;AAC7D,qCAAqC,uBAAuB,EAAE;AAC9D,qCAAqC,sBAAsB,EAAE;AAC7D,qCAAqC,uBAAuB,EAAE;;AAE9D;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;AACF;;AAEA,sCAAsC;AACtC;EACE,uBAAuB;AACzB;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;AAClB","sourcesContent":[":root {\n  --primary-gray: #d9d9d9;\n  --white: #ffffff;\n  --black: #000000;\n  --transparent: rgba(255, 255, 255, 0.1);\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.navbar {\n  background: var(--transparent);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-bottom: 1px solid rgba(217, 217, 217, 0.1);\n  transition: all 0.3s ease;\n  z-index: 1000;\n}\n\n/* Sticky only on desktop */\n@media (min-width: 769px) {\n  .navbar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n  \n  /* Add padding to body to compensate for fixed navbar */\n  body {\n    padding-top: 80px;\n  }\n}\n\n.navbar-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 1rem 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  background-color: #ffffff;\n}\n\n/* Logo Styles */\n.navbar-logo {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: bold;\n  color: var(--white);\n}\n\n.logo-f {\n  background: var(--primary-gray);\n  color: var(--black);\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  font-size: 1.2rem;\n  font-weight: bold;\n}\n\n.logo-text {\n  color: #000000;\n  font-size: 1.6rem;\n  letter-spacing: 2px;\n  font-weight: 400;\n}\n\n/* Desktop Menu */\n.desktop-menu {\n  display: flex;\n  list-style: none;\n  gap: 2rem;\n}\n\n.desktop-menu li a {\n  color: var(--black);\n  text-decoration: none;\n  font-weight: 400;\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n  position: relative;\n  padding: 0.5rem 0;\n}\n\n.desktop-menu li a:hover {\n  color: var(--black);\n}\n\n.desktop-menu li a::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 0;\n  height: 1px;\n  background: var(--white);\n  transition: width 0.3s ease;\n}\n\n.desktop-menu li a:hover::after {\n  width: 100%;\n}\n\n/* Mobile Menu Button */\n.mobile-menu-button {\n  display: none;\n  flex-direction: column;\n  cursor: pointer;\n  padding: 0.5rem;\n  z-index: 1001;\n}\n\n.hamburger {\n  width: 25px;\n  height: 2px;\n  background: var(--black);\n  margin: 3px 0;\n  transition: all 0.3s ease;\n  transform-origin: center;\n}\n\n.mobile-menu-button.active .hamburger:nth-child(1) {\n  transform: rotate(45deg) translate(6px, 6px);\n}\n\n.mobile-menu-button.active .hamburger:nth-child(2) {\n  opacity: 0;\n}\n\n.mobile-menu-button.active .hamburger:nth-child(3) {\n  transform: rotate(-45deg) translate(6px, -6px);\n}\n\n/* Mobile Menu */\n.mobile-menu {\n  position: fixed;\n  top: 0;\n  right: -100%;\n  width: 280px;\n  height: 100vh;\n  -webkit-backdrop-filter: blur(20px);\n  transition: right 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  z-index: 999;\n}\n\n.mobile-menu.active {\n  right: 0;\n}\n\n.mobile-menu-items {\n  z-index: 1001;\n  list-style: none;\n  padding: 100px 2rem 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.mobile-menu-items li {\n  z-index: 1001;\n  opacity: 0;\n  transform: translateX(30px);\n  transition: all 0.3s ease;\n  transition-delay: 0.1s;\n}\n\n.mobile-menu.active .mobile-menu-items li {\n  z-index: 1001;\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.mobile-menu-items li:nth-child(1) { transition-delay: 0.1s; }\n.mobile-menu-items li:nth-child(2) { transition-delay: 0.15s; }\n.mobile-menu-items li:nth-child(3) { transition-delay: 0.2s; }\n.mobile-menu-items li:nth-child(4) { transition-delay: 0.25s; }\n.mobile-menu-items li:nth-child(5) { transition-delay: 0.3s; }\n.mobile-menu-items li:nth-child(6) { transition-delay: 0.35s; }\n\n.mobile-menu-items li a {\n  color: var(--primary-gray);\n  text-decoration: none;\n  font-size: 1.1rem;\n  font-weight: 300;\n  padding: 1rem 0;\n  display: block;\n  transition: all 0.3s ease;\n  border-bottom: 1px solid rgba(217, 217, 217, 0.1);\n}\n\n.mobile-menu-items li a:hover {\n  color: var(--white);\n  padding-left: 1rem;\n}\n\n/* Menu Overlay */\n.menu-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n  z-index: 1001;\n}\n\n.menu-overlay.active {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .navbar-container {\n    padding: 1rem 1.5rem;\n  }\n  \n  .desktop-menu {\n    display: none;\n  }\n  \n  .mobile-menu-button {\n    display: flex;\n  }\n  \n  .logo-text {\n    font-size: 1rem;\n    letter-spacing: 1.5px;\n  }\n  \n  .logo-f {\n    width: 28px;\n    height: 28px;\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .navbar-container {\n    padding: 1rem 1rem;\n  }\n  \n  .mobile-menu {\n    width: 100%;\n  }\n  \n  .mobile-menu-items {\n    z-index: 9999;\n    padding: 80px 2rem 2rem;\n  }\n}\n\n/* Smooth scrolling for anchor links */\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* Hide scrollbar when menu is open */\nbody.menu-open {\n  overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
